import { TranslationOptions } from 'owa-outlook-service-options';
import getUserLanguageName from './getUserLanguageName';
import getLanguageNameFromTag from './getLanguageNameFromTag';
import getTranslationOptions from 'owa-translation/lib/utils/getTranslationOptions';

export default function getTargetLanguageName(): string {
    const options: TranslationOptions = getTranslationOptions();
    return options.targetLanguage
        ? getLanguageNameFromTag(options.targetLanguage)
        : getUserLanguageName();
}
